import { render } from "./editRoute.vue?vue&type=template&id=b94feace"
import script from "./editRoute.vue?vue&type=script&lang=js"
export * from "./editRoute.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__